var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEyeClosed = function SvgEyeClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.84 11.884c-4.066 6.512-13.614 6.512-17.68 0l-.794.616c.186.292.382.572.587.84l-1.307 1.306.708.707 1.244-1.244c.852.93 1.826 1.682 2.877 2.257L5.1 18.2l.8.6 1.49-1.986c1.306.569 2.703.883 4.11.943V20h1v-2.243a11.545 11.545 0 0 0 4.1-.939l.953 1.905.894-.447-.948-1.896a11.171 11.171 0 0 0 2.92-2.29l1.49 1.288.654-.757-1.503-1.298c.2-.263.392-.537.574-.823l-.794-.616Z",
    fill: "#232837"
  })));
};

export default SvgEyeClosed;